import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container py-9" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-4" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "password"
}, " Indtast CVR- eller CPR-nummer: ", -1)
const _hoisted_6 = ["pattern"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", {
  id: "submitButton",
  class: "button button-primary mt-2",
  type: "submit"
}, " Log Ind ", -1)
const _hoisted_8 = { class: "col-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RichText = _resolveComponent("RichText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.login()), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _withDirectives(_createElementVNode("input", {
              id: "password",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputAdminSecret) = $event)),
              class: "form-input validity",
              maxlength: "10",
              minlength: "8",
              name: "password",
              pattern: _ctx.findRegexPattern('regex.validation.admin-secret-password'),
              required: "",
              type: "text"
            }, null, 8, _hoisted_6), [
              [_vModelText, _ctx.inputAdminSecret]
            ])
          ]),
          _hoisted_7
        ], 32)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_RichText, { "text-key": "login.loginText" })
      ])
    ])
  ]))
}